import { useEffect } from 'react'
import axios from 'axios'
import 'react-loading-skeleton/dist/skeleton.css'
import { default as ObituaryListFull } from './obituary-full/ObituaryList'
import { default as ObituaryListGallery } from './obituary-gallery/ObituaryList'
import { useDispatch } from 'react-redux'
import { setSearchQuery } from '../store/navigation'

export default function App({ data }) {

    const dispatch = useDispatch()

    const queryParams = Object.fromEntries(new URLSearchParams(window.location.search).entries())

    useEffect(() => {
        if (queryParams.q) {
            dispatch(setSearchQuery(queryParams.q))
        }
    }, [])

    const token = data.getAttribute('data-token')

    const props = {
        photoShape: data.getAttribute('data-photo-shape'),
        showViewAllButton: data.getAttribute('data-show-view-all-button'),
        searchRedirectUrl: data.getAttribute('data-search-redirect-url'), // depreciated
        showSearch: data.getAttribute('data-show-search'),
        limit: data.getAttribute('data-limit') || 10,
        showFlowersButton: data.getAttribute('data-show-flowers-button'),
        showFlowersIcon: data.getAttribute('data-show-flowers-icon'),
        target: data.getAttribute('data-target')
    }

    axios.interceptors.request.use(
        (config) => {
            config.headers['Authorization'] = `Bearer ${token}`
            return config
        },
    )

    if (data.getAttribute('data-organization-id')) {
        axios.defaults.headers.common['X-Organization-Id'] = data.getAttribute('data-organization-id')
    }

    return (
        <>
            {data.getAttribute('data-format') == 'gallery'
                ? <ObituaryListGallery props={props} />
                : <ObituaryListFull props={props} searchQueryParam={queryParams?.q} />
            }
        </>
    )
}
